import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import { useText, useGetAvatarUrl } from 'common/hooks';
import LazyImage from 'common/components/LazyImage';
import { getIndicator, getIndicatorConfig } from 'utils/common';

import { Wrapper, Loader, Avatar, ToolTip, Label } from './elements';

const deps = {
  uid: state.appContainer.user.uid,
  profiles: state.appContainer.profiles,
  indicator: state.challenge.campaign.indicator,
  totalUserStats:
    state.challenge.stats.total.profiles[state.appContainer.user.uid],
  tutorialActivityLogged: state.challenge.tutorial.tutorialActivityLogged,
};

function TotalSavings({
  uid,
  profiles,
  indicator = 'default',
  totalUserStats,
  tutorialActivityLogged,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const getAvatarUrl = useGetAvatarUrl();
  const imagePath = getAvatarUrl(profiles[uid]).large;
  const { icon, color, precision } = getIndicatorConfig(indicator);

  let usersScore = totalUserStats || { co2: 0, points: 0 };

  if (tutorialActivityLogged) {
    usersScore = {
      ...(totalUserStats || {}),
      co2: (usersScore.co2 || 0) + 1606670,
      points: (usersScore.points || 0) + 5000000,
    };
  }

  const totalUserSavings = getIndicator(usersScore, indicator);

  return (
    <Wrapper>
      <LazyImage
        key={'profile-image'}
        path={imagePath}
        onLoading={() => <Loader />}
        onLoaded={url => <Avatar src={url} />}
      />
      <ToolTip
        text={t(`challenge.ChaPaD24B.PersonalInsights.tooltip.${indicator}`)}
      >
        <Label
          decimals={precision}
          icon={icon}
          iconColor={color}
          label={t(
            `challenge.ChaPaD24B.PersonalInsights.your_total_savings.${indicator}`
          )}
          value={totalUserSavings}
          locale={t.fullLocale}
        />
      </ToolTip>
    </Wrapper>
  );
}

export default connect(deps, TotalSavings);
